import React from 'react';
import { FieldTemplateProps } from '@rjsf/utils';

const HorizontalFieldTemplate = ({
    id,
    label,
    help,
    required,
    description,
    errors,
    children,
    displayLabel,
    classNames,
    disabled,
    readonly,
    schema,
    uiSchema,
    onKeyChange,
    onDropPropertyClick
}: FieldTemplateProps) => {
    // Don't render horizontal layout for checkboxes, which have their own layout
    if (schema.type === 'boolean') {
        return (
            <div className={`mb-2 ${classNames}`}>
                <div>{children}</div>
                {errors}
                {help}
                {description && (
                    <div className="form-description-container">
                        <div className="form-field-description">
                            {description}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    // For nested objects/arrays, use vertical layout
    if (schema.type === 'object' || schema.type === 'array') {
        return (
            <div className={`mb-2 ${classNames}`}>
                {displayLabel && label && <div>{label}</div>}
                <div>{children}</div>
                {errors}
                {help}
                {description && (
                    <div className="form-description-container">
                        <div className="form-field-description">
                            {description}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={`mb-6 border-b border-gray-lines last:border-b-0 pb-6 ${classNames} transition-all duration-300 w-full`}>
            <div className="flex flex-row items-start justify-between w-full gap-6">
                <div className="pt-2 flex-grow">
                    {displayLabel && label}
                </div>
                <div className="w-1/2">
                    <div>{children}</div>
                    {errors}
                    {help}
                </div>
            </div>
            {description && (
                <div className="form-description-container">
                    <div className="form-field-description">
                        {description}
                    </div>
                </div>
            )}
        </div>
    );
};

export default HorizontalFieldTemplate;
